import { useMutation, useQuery } from "react-query";
import DashboardMaster from "../dashboard/dashboard-master-layout.component";
import React, { ReactElement } from "react";
import { useParams } from "react-router";
import { Field, Form } from "react-final-form";
import { AInput } from "../../form/final-form-antd";
import { Required } from "../../form/validations";
import SubmitButton from "../../global-components/submit-button.component";
import {
  editSubscriber,
  getSubscriber,
  saveSubscriber,
} from "./subscriber.thunks";
import { SubscriberInterface } from "./subscriber.interface";

const SubscriberForm = (): ReactElement => {
  const { id }: { id: string } = useParams();
  const mutation =
    id !== "new" ? useMutation(editSubscriber) : useMutation(saveSubscriber);
  let data;
  if (id !== "new") {
    ({ data } = useQuery(["id", { id }], () => getSubscriber(id)));
  }

  return (
    <>
      <DashboardMaster
        showAdd={false}
        title={id !== "new" ? "Edit subscriber" : "Create new subscriber"}
      >
        <Form
          onSubmit={(values) => mutation.mutate(values as SubscriberInterface)}
          initialValues={data}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit} autoComplete="off">
              <Field
                label="Name"
                name="data.name"
                columns={1}
                component={AInput}
                hasFeedback
                validate={Required}
              />
              <Field
                label="Email"
                name="email"
                columns={1}
                component={AInput}
                hasFeedback
                validate={Required}
              />
              <div className="wrapper-two-column">
                <div />
                <div>
                  <SubmitButton />
                </div>
              </div>
            </form>
          )}
        />
      </DashboardMaster>
    </>
  );
};
export default SubscriberForm;
